<template>
    <div>
        <div class="row" v-if="items.length">
            <div class="col-12" v-for="(item, index) in items" :key="index">
                <div class="card" v-if="item._id">
                    <div class="card-body">
                        <div class="row align-items-center">
                            <div class="col-auto">
                                <avatar :src="item.product.avatar ? item.product.avatar.preview : ''"/>
                            </div>
                            <div class="col">
                                <h6 class="card-title text-uppercase text-muted mb-2">{{ item.category.label}}</h6>
                                <span class="h2 mb-0 numbers">{{ item.product.label }}</span>
                                <span
                                    class="badge badge-soft-secondary mt-n1 ml-1"
                                    :class="{'badge-soft-success':item.percentage>0,'badge-soft-danger':item.percentage<0}"
                                >{{ item.percentage }}%</span>
                            </div>
                            <div class="col-auto">
                                <money :value="item.total"/>
                            </div>
                            <div class="col-auto">
                                <span class="h2 mb-0 numbers">{{ item.quantity }}</span>
                                <span class="h2 mb-0 numbers">{{ $t(item.product.measurement) }}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-else class="row">
            <div class="col-12 text-center">
                <div class="card">
                    <div class="card-body">{{$t("Nothing yet")}}</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Money from '@/components/Money.vue';
    import Avatar from '@/components/Avatar.vue';
    import {mapActions} from 'vuex';

    export default {
        components: {
            Money,
            Avatar
        },
        props: {branchesId: Array, user: Array, dates: Object},
        data() {
            return {
                items: [],
                params: {
                    query: {},
                },
            }
        },
        watch: {
            user(newUser) {
                this.fetchSalesReport();
            },
            dates(dates) {
                this.fetchSalesReport();
            },
            branchesId(newValue) {
                this.fetchSalesReport();
            }
        },
        computed: {},
        created() {
            this.fetchSalesReport();
        },
        methods: {
            ...mapActions('product-reports', ['find']),

            fetchSalesReport() {
                let query = {};
                if (this.dates.start) {
                    query.date = {
                        $gte: this.dates.start,
                        $lte: this.dates.end
                    }
                }

                if (this.branchesId.length > 0)
                    query.branchesId = this.branchesId;

                if (this.user.length > 0)
                    query.user = {$in: this.user};

                this.find({query}).then(data => {
                    this.items = [];
                    if (data.length <= 0) return;
                    this.items = data
                });
            },


        }
    }
</script>

<style>

</style>
